<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>部门：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.name"
                placeholder="请输入商品名称"/>

      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary" @click="createdata" size="medium" round><i class="el-icon-circle-plus"></i>新建部门
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>
    </div>
    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column
          label="部门"
          prop="deptName" align="center">
      </el-table-column>
      <el-table-column
          label="负责人" :formatter="formatUsername"
          prop="leader" align="center">

      </el-table-column>
      <el-table-column
          label="联系电话"
          prop="phone" align="center">
      </el-table-column>
      <el-table-column
          align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="handleEdit( scope.row)">
            <i class="el-icon-setting"></i>
            信息维护
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleterole(scope.$index, scope.row)"><i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template>
      <div>
        <pagination
            id="companyListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>
    <el-dialog id="cdia" :title="selectTable.title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="selectTable" :rules="formRules"
               ref="selectForm">   <!-- 添加ref用于触发校验 -->
        <el-form-item label="部门名称:" label-width="100px" prop="deptName">
          <el-input v-model="selectTable.deptName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人:" label-width="100px" prop="leader">
          <el-select v-model="selectTable.leader" placeholder="请选择"
                     style="    width: 100%;">
            <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.nickname"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话:" label-width="100px" prop="phone">
          <el-input v-model="selectTable.phone" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    // 自定义校验规则（例如：手机号校验）
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    return {
      formRules: {
        deptName: [
          {required: true, message: '部门名称不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        leader: [
          {required: true, message: '请选择联系人', trigger: 'change'}
        ],
        phone: [
          {required: true, message: '联系电话不能为空', trigger: 'blur'},
          {validator: validatePhone, trigger: 'blur'}
        ]
      },
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        status: 1,
      },
      userList: [],
      selectTable: {
        title: '',
        id: 0,
        status: 1,
        name: undefined,
        state: 1,
      },

      // 菜单列表
      dialogFormVisible: false,
      tableData: [],
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.getuserList();
  },
  methods: {
    formatUsername(row, column, cellValue) {
      // 从 optionskhlx 中查找对应的 label
      const option = this.userList.find(item => item.id === cellValue);
      return option ? option.nickname : "暂无";
    },
    getuserList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/getUserList",
        success: (data) => {
          this.userList = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    createtree() {
      this.$refs.selectForm.validate((valid) => {
        if (valid) {
          this.$request.postHttp({
            url: "/system/saveDeptInfo",
            data: JSON.stringify(this.selectTable),
            success: (data) => {
              this.$message.success(data.msg)
              this.dialogFormVisible = false
              this.getList();
            },
            error: (error) => {
              console.error("Error:", error);
              // 执行失败时的操作
            },
          })
        } else {
          // 校验失败
          this.$message.error('请完善表单信息');
          return false;
        }
      });


    },


    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/DeptList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    deleterole(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/system/deletedp",
          params: {rid: row.id},
          success: (data) => {
            this.$message.success('删除成功！')

            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    createdata() {
      this.selectTable = this.$options.data().selectTable
      this.selectTable.title = '添加部门信息'
      this.dialogFormVisible = true;
      if (this.$refs.selectForm) {
        this.$refs.selectForm.clearValidate();  // 清空所有验证提示
      }
    },
    handleEdit(row) {
      this.selectTable.id = row.id
      this.$request.getHttp({
        url: "/system/getDeptinfo",
        params: {id: this.selectTable.id},
        success: (data) => {
          this.selectTable = data.data
          if (this.$refs.selectForm) {
            this.$refs.selectForm.clearValidate();  // 清空所有验证提示
          }
          if (this.selectTable.id == null) {
            this.selectTable.id = 0
          }
          if (this.selectTable.id > 0) {
            this.selectTable.title = '修改部门信息'
          } else {
            this.selectTable.title = '添加部门信息'
          }

          this.dialogFormVisible = true;
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },


  },
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

/* 如果 ::v-deep 不行，试试 /deep/ */
.price-management-page .el-input-number .el-input__inner {
  text-align: left !important;
}

#cdia .el-dialog {
  margin-top: 7vh !important;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>